/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Lines_CaptionInputs */

const vi_einvoice_draft_lines_caption = /** @type {(inputs: Einvoice_Draft_Lines_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các dòng hàng trên nháp hóa đơn`)
};

/**

* @param {Einvoice_Draft_Lines_CaptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_lines_caption = /** @type {((inputs?: Einvoice_Draft_Lines_CaptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Lines_CaptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_lines_caption(inputs)
});